import type { DownloadStructure } from '@/types/download';
import { storage } from '@/utils/storage';

const DOWNLOAD_STRUCTURE_KEY = 'download_structure_preference';

export function getStoredDownloadStructure(): DownloadStructure {
  return storage.get<DownloadStructure>(DOWNLOAD_STRUCTURE_KEY) ?? 'flat';
}

export function setStoredDownloadStructure(value: DownloadStructure): void {
  storage.set(DOWNLOAD_STRUCTURE_KEY, value);
}

export function getDownloadStructurePreviewPath(structure: DownloadStructure, mode: 'processed' | 'raw'): string {
  const filename = mode === 'raw' ? 'activity-123_raw-data.json' : 'activity-123.json';

  if (structure === 'folders') {
    return `patient-id/activity-123/${filename}`;
  }

  return `patient-id/${filename}`;
}
